import * as keyapis_dial_v1_alert_scenario_pb from "./v1/keyapis_dial_alert_scenario_v1.pb";
import * as keyapis_dial_v1_call_pb from "./v1/keyapis_dial_call_v1.pb";
import * as keyapis_dial_v1_emergency_pb from "./v1/keyapis_dial_emergency_v1.pb";

export default {
  v1: {
    resources: {
      alertScenario: keyapis_dial_v1_alert_scenario_pb,
      call: keyapis_dial_v1_call_pb,
      emergency: keyapis_dial_v1_emergency_pb,
    },
  },
};
